<template>
	<footer class="theme_footer">
		<img
			class="footer_deco"
			:src="require('@/assets/images/footer_new.png')"
			title=""
			alt="">
		<div class="container">
			<div class="logo">
				<a href="/">
					<img
						:src="require('@/assets/images/footer_logo.png')"
						alt="">
				</a>
			</div>
			<div class="menu-footer-menu-container">
				<ul>
					<li
						v-for="(item, index) in menuFooter"
						:key="index"
						class="menu-item">
						<a
							:href="item.url"
							:target="item.target">{{ item.text }}</a>
					</li>
				</ul>
			</div>
		</div>
		<p class="copyright">
			All rights reserved
		</p>
	</footer>
</template>

<script setup>
const menuFooter = [
	{
		url: 'https://bulldroids.com/terms-conditions/',
		text: 'Terms & Conditions',
		target: '',
	},
	{
		url: 'https://bulldroids.com/contact/',
		text: 'The Full Story',
		target: '',
	},
	{
		url: 'https://bulldroids.com/faq/',
		text: 'White List',
		target: '',
	},
	{
		url: 'https://bulldroids.com/contact/',
		text: 'Contact',
		target: '',
	},
];
</script>
